import Content from "./Content";
import Header from "../../common/Popup/Header";
import { Modal, Typography } from "@mui/material";

const customStyles = {
  modal: {
    width: "550px",
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    outline: "none",
  },
};

interface IClassDetailsProps {
  open: boolean;
  onClose(): void;
}
function ClassDetails({ open, onClose }: IClassDetailsProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Typography component="div" sx={customStyles.modal}>
        <Header onClose={onClose} title="" />
        <Content onSubmit={onClose} />
      </Typography>
    </Modal>
  );
}

export default ClassDetails;
